@if (storeMenu()) {
    <app-container>
        <section class="flex overflow-hidden relative w-screen h-screen">
            <ng-container *ngTemplateOutlet="menuSection" />
            <div class="overflow-hidden w-full h-full">
                <app-top-bar
                    [header]="
                        currentChildMenu()?.name || currentMenu()?.name || ''
                    "
                    [description]="
                        currentChildMenu()?.description ||
                        currentMenu()?.description ||
                        ''
                    "
                />
                <div
                    id="layout-content"
                    class="size-full p-4 overflow-y-auto md:pb-[10rem] bg-gray-50"
                >
                    <router-outlet />
                </div>
            </div>
        </section>
    </app-container>
} @else {
    <div class="flex w-screen h-screen justify-center items-center">
        <app-spinner />
    </div>
}

<ng-template #menuSection>
    <app-side-menu
        logo="https://malirang.com/logo.svg"
        title=""
        class="hidden md:block"
    >
        @for (menu of menus(); track $index) {
            @if (!menu.hidden) {
                @if (menu.children && menu.children.length > 0) {
                    <app-side-menu-item-group
                        [active]="currentMenu() === menu"
                        [label]="menu.name"
                        [icon]="menu.icon!"
                    >
                        @for (child of menu.children; track $index) {
                            @if (!child.hidden) {
                                <app-side-menu-item-child
                                    (click)="navigate(child)"
                                    [active]="currentChildMenu() === child"
                                    >{{ child.name }}</app-side-menu-item-child
                                >
                            }
                        }
                    </app-side-menu-item-group>
                } @else {
                    <app-side-menu-item
                        (click)="navigate(menu)"
                        [active]="currentMenu() === menu"
                        [icon]="menu.icon!"
                        >{{ menu.name }}</app-side-menu-item
                    >
                }
            }
        }
    </app-side-menu>
</ng-template>
